import getRequest from './getRequest';
import postRequest from './postRequest';
import patchRequest from './patchRequest';
import putRequest from './putRequest';
import deleteRequest from './deleteRequest';

const base = (institutionId) => `/institutions/${institutionId}/whatsapp`;

export function getWhatsapp(institutionId) {
  return getRequest(base(institutionId), '');
}

export function connectWhatsapp(institutionId, payload) {
  return postRequest.object(`${base(institutionId)}/connect`, payload);
}

export function updateWhatsappSettings(institutionId, data) {
  return patchRequest(`${base(institutionId)}/settings`, '', data);
}

export function updatePrivateContacts(institutionId, contacts) {
  return putRequest(`${base(institutionId)}/private-contacts`, '', { contacts });
}

export function notifyWhatsappBot(institutionId) {
  return postRequest.object(`${base(institutionId)}/notify-bot`, {});
}

export function requestWhatsappSync(institutionId) {
  return postRequest.object(`${base(institutionId)}/sync`, { force: true });
}

export function refreshWhatsapp(institutionId, payload = {}) {
  return postRequest.object(`${base(institutionId)}/refresh`, payload);
}

export function getWhatsappBotRules(institutionId) {
  return getRequest(`${base(institutionId)}/bot-rules`, '');
}

export async function putWhatsappBotRules(institutionId, payload) {
  const res = await putRequest(`${base(institutionId)}/bot-rules`, '', payload);
  return res.data;
}

const listPath = (kind) => (kind === 'always_reply' ? '/bot-rules/always-reply' : '/bot-rules/excluded');

export async function addWhatsappBotRulesList(institutionId, kind, payload) {
  const res = await postRequest.object(`${base(institutionId)}${listPath(kind)}`, payload);
  return res.data;
}

export async function deleteWhatsappBotRulesList(institutionId, kind, payload) {
  const q = `number=${encodeURIComponent(payload.number)}`;
  const res = await deleteRequest(`${base(institutionId)}${listPath(kind)}`, q);
  return res.data;
}

export function getWhatsappExcludedList(institutionId, params = {}) {
  const parts = [];
  if (params.search) parts.push(`search=${encodeURIComponent(params.search)}`);
  if (params.page) parts.push(`page=${encodeURIComponent(params.page)}`);
  if (params.limit) parts.push(`limit=${encodeURIComponent(params.limit)}`);
  const query = parts.join('&');
  return getRequest(`${base(institutionId)}/bot-rules/excluded`, query);
}

export async function previewWhatsappExcludedImport(institutionId, file, defaultCountryCode) {
  const formData = new FormData();
  formData.append('file', file);
  if (defaultCountryCode) {
    formData.append('default_country_code', String(defaultCountryCode).replace(/\D/g, ''));
  }
  const res = await postRequest.formData(
    `${base(institutionId)}/bot-rules/excluded/import/preview`,
    '',
    formData,
  );
  return res.data;
}

export async function confirmWhatsappExcludedImport(institutionId, importToken) {
  const res = await postRequest.object(
    `${base(institutionId)}/bot-rules/excluded/import/confirm`,
    { import_token: importToken },
  );
  return res.data;
}

export async function bulkRemoveWhatsappExcluded(institutionId, numbers) {
  const res = await postRequest.object(
    `${base(institutionId)}/bot-rules/excluded/remove`,
    { numbers },
  );
  return res.data;
}

export async function deleteWhatsappExcludedNumber(institutionId, number) {
  const res = await deleteRequest(
    `${base(institutionId)}/bot-rules/excluded/${encodeURIComponent(number)}`,
    '',
  );
  return res.data;
}

export async function clearWhatsappExcludedList(institutionId) {
  const res = await deleteRequest(
    `${base(institutionId)}/bot-rules/excluded`,
    'confirm=all',
  );
  return res.data;
}

export async function undoWhatsappExcludedImport(institutionId, importId) {
  const res = await deleteRequest(
    `${base(institutionId)}/bot-rules/excluded/import/${encodeURIComponent(importId)}`,
    '',
  );
  return res.data;
}
